import { usageIds } from "../constants/usageid.js";
export var UserSchemaIds;
(function (UserSchemaIds) {
    UserSchemaIds["USER"] = "user";
    UserSchemaIds["USER_WITH_EMAIL"] = "userWithEmail";
    UserSchemaIds["CREATE_MEMBER"] = "createMember";
    UserSchemaIds["MEMBER_PROFILE"] = "memberProfile";
    UserSchemaIds["USER_PROFILE"] = "userProfile";
})(UserSchemaIds || (UserSchemaIds = {}));
;
export var UserTags;
(function (UserTags) {
    UserTags["DEFAULT"] = "default";
    UserTags["TEAM"] = "team";
    UserTags["ACCOUNT_AS_TEAM"] = "accountAsTeam";
    UserTags["ACCOUNT_AS_ACCOUNT"] = "accountAsAccount";
    UserTags["MEMBER_AS_TEAM"] = "memberAsTeam";
    UserTags["MEMBER_AS_ACCOUNT"] = "memberAsAccount";
    UserTags["DOMAIN"] = "domain";
})(UserTags || (UserTags = {}));
;
export const UserTagsMap = {
    [UserSchemaIds.USER_WITH_EMAIL]: [
        UserTags.TEAM,
        UserTags.ACCOUNT_AS_TEAM,
        UserTags.ACCOUNT_AS_ACCOUNT,
        UserTags.MEMBER_AS_TEAM,
        UserTags.MEMBER_AS_ACCOUNT,
        UserTags.DOMAIN,
    ],
    [UserSchemaIds.CREATE_MEMBER]: [UserTags.DEFAULT],
    [UserSchemaIds.MEMBER_PROFILE]: [UserTags.DEFAULT],
    [UserSchemaIds.USER_PROFILE]: [UserTags.DEFAULT],
};
export const UserUsageIds = usageIds(UserTagsMap);
